import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5zm0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zM16.055 13.6952c-1.146.818-2.543 1.305-4.055 1.305-1.512 0-2.909-.487-4.055-1.305-2.358.87-3.945 2.47-3.945 4.305v3.8h16v-3.8c0-1.835-1.587-3.435-3.945-4.305zM18 18.0002c0-.704-.691-1.476-1.789-2.053-1.294.692-2.73 1.053-4.211 1.053-1.481 0-2.917-.361-4.211-1.053-1.097.577-1.789 1.349-1.789 2.053v1.8h12v-1.8z",
    fill: "currentColor"
  }));
});